import {Component, OnInit} from "@angular/core";
import {RoleService} from "../../services/role.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: "app-redirect-role-decider",
  templateUrl: "./redirect-role-decider.component.html",
  styleUrls: ["./redirect-role-decider.component.css"]
})
export class RedirectRoleDeciderComponent implements OnInit {

  constructor(
    private roleService: RoleService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    let returnUrl = this.route.snapshot.queryParams["returnUrl"] || "";
    if (returnUrl == "" || returnUrl == "/login") {
      returnUrl = "orders";
    }

    if (this.roleService.hasRoles("wallet")) {
      this.router.navigate(["loads", "partner-wallet"]).then();
    } else if (this.roleService.hasRoles("partner_support") && !this.roleService.hasRoles("partner")) {
      this.router.navigate(["customers-overview"]).then();
    } else if (this.roleService.hasRoles("collection_external")) {
      this.router.navigate(["collection-search"]).then();
    } else if (this.roleService.hasRoles("compliance") || this.roleService.hasRoles("compliance_manager")) {
      this.router.navigate(["risk", "check"]).then();
    } else if (this.roleService.hasRoles("issuer_external")) {
      this.router.navigate(["customers-overview"]).then();
    } else if (this.roleService.hasRoles("marketing")) {
      this.router.navigate(["marketing", "stats"]).then();
    } else {
      this.router.navigate([returnUrl]).then();
    }
  }

}
